import React from 'react';
import { connect } from 'react-redux';
import { scheduleCalendarOperations } from 'pages/ScheduleCalendar/duck';
import DeleteShiftComponent from './DeleteShiftComponent';

const mapStateToProps = ({
  scheduleCalendarReducer,
}) => {
  return {
    allUsers: scheduleCalendarReducer.allUsers.users,
    applicants: scheduleCalendarReducer.applicants.data,
  };
};

const mapDispatchToProps = (dispatch) => {

  const deleteShiftDispatch = (shiftId, locationId) => {
    dispatch(scheduleCalendarOperations.deleteShiftOperation(shiftId, locationId));
  };

  const revokeApprovedChildCardShiftDispatch = (shiftId ) => {
    dispatch(scheduleCalendarOperations.revokeApprovedChildCardShiftOperation(shiftId));
  }
  
  return {
    deleteShiftDispatch,
    revokeApprovedChildCardShiftDispatch,
  };
};

const DeleteShiftComponentContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {
  const {
    deleteShiftDispatch,
    revokeApprovedChildCardShiftDispatch,
  } = props;

  return <DeleteShiftComponent
    deleteShiftDispatch = {deleteShiftDispatch}
    revokeApprovedChildCardShiftDispatch = {revokeApprovedChildCardShiftDispatch}
    {...props}
  /> 
});

export default DeleteShiftComponentContainer;